import React, { useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

import AdviceSection from '../common/AdviceSection';
import SectionCard from '../common/cards/SectionCard';

const SocialDialogue = props => {

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22008 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
	}, [])


	return(
		<div className="social-dialogue">
			<AdviceSection literals={ props.literals } section={["osh-steering","social-dialogue"]} methodologyData={{section: 'osh-steering', subsection: 'Social dialogue in EU countries', indicator: 354}} />

			<section className="container-fluid background-gray section--page ">
				<div className="container">
					<h2 className="title-section second-color">{ props.literals.L20708 }</h2>
					<section className="card--grid xxs-w1 w3 center-text">
						<SectionCard
							iconClass = "dialogue-icon"
							link = "/osh-steering/social-dialogue/development-eu-countries"
							title = { props.literals.L20810 }
							text = { props.literals.L22041 }
							seeMore = { props.literals.L480 }
						/>
						<SectionCard
							iconClass = "social-dialogue-composite-icon"
							link = "/osh-steering/social-dialogue/social-dialogue-indicator"
							title = { props.literals.L20811 }
							text = { props.literals.L20815 }
							seeMore = { props.literals.L480 }
						/>
						<SectionCard
							iconClass = "workers-icon"
							link = "/osh-steering/social-dialogue/worker-involvement"
							title = { props.literals.L22015 }
							text = { props.literals.L22060 }
							seeMore = { props.literals.L480 }
						/>
					</section>
				</div>
			</section>
		</div>
	)
}
SocialDialogue.displayName = 'SocialDialogue';
export default SocialDialogue;